import { Alert, AlertTitle, Button, Collapse } from '@mui/material'

import useConfig from 'hooks/useConfig'

export const SampleDataAlert = () => {
  const { sampleData, onChangeSampleData } = useConfig()

  return (
    <Collapse in={sampleData}>
      <Alert
        action={
          <Button
            sx={{
              mr: 1,
              px: '6px!important',
            }}
            variant="contained"
            color="secondary"
            aria-label="close"
            onClick={onChangeSampleData}>
            Switch off
          </Button>
        }
        severity="warning"
        sx={{
          backgroundColor: 'var(--mui-palette-warning-light)',
          border: '1px solid var(--mui-palette-warning-main)',
          p: 1,
          borderRadius: '12px',
        }}>
        <AlertTitle sx={{ m: 0, fontWeight: 600 }}>
          You are seeing sample data
        </AlertTitle>
      </Alert>
    </Collapse>
  )
}
